




















import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import ContactWithHistory from '~/components/car/classifieds/view/partials/ContactWithHistory.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CCard, ContactWithHistory },
  props: {
    classified: { type: Object, required: true },
    showContact: { type: Boolean, required: false, default: false },
    goToMessagesOnLoad: { type: Boolean, required: false, default: false },
    withoutCard: { type: Boolean, default: false },
    useStore: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      formShowing: true
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, [
      'sellerIsBlacklistedSuspiciousOrFraudster',
      'isPlotClassified'
    ]),
    ...mapState(CLASSIFIED_VIEW_NS, ['contactFormExtraText']),
    title() {
      if (this.withoutCard) {
        return null
      }
      return this.formShowing
        ? this.$i18n.t('contact')
        : this.$i18n.t('message history for classified')
    }
  },
  mounted() {
    this.$emit('mounted')
  },
  methods: {
    handleFormShowing(status: boolean) {
      this.$emit('form-showing', status)
      this.formShowing = status
    }
  }
})
